import {BrowserRouter} from "react-router-dom"
import {ContextProvider} from './Context'
import {Router} from "./pages/Router"
import {Layout} from "./modules/layout/Layout"
import './App.css'

function App() {
  return (
      <BrowserRouter>
          <ContextProvider>
              <Layout>
                  <Router />
              </Layout>
          </ContextProvider>
      </BrowserRouter>
  );
}

export default App;
